import React, { useEffect, useState } from 'react';
import { Pin, PinOff } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { API } from '@/App';

const authHeaders = () => {
  const t = localStorage.getItem('session_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

/**
 * PinButton — toggles a user's pin on a tour / vendor / customer / team record.
 * Pin state is checked on mount via GET /me/pins.
 */
const PinButton = ({ entityType, entityId, size = 'sm', variant = 'outline' }) => {
  const [pinned, setPinned] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!entityId) return;
    (async () => {
      try {
        const res = await fetch(`${API}/pollen/me/pins`, { credentials: 'include', headers: authHeaders() });
        if (!res.ok) return;
        const pins = await res.json();
        setPinned(pins.some(p => p.entity_type === entityType && p.entity_id === entityId));
      } catch { /* noop */ }
    })();
  }, [entityType, entityId]);

  const toggle = async () => {
    if (!entityId || loading) return;
    setLoading(true);
    try {
      if (pinned) {
        const res = await fetch(`${API}/pollen/me/pins/${entityType}/${entityId}`, { method: 'DELETE', credentials: 'include', headers: authHeaders() });
        if (res.ok) { setPinned(false); toast.success('Unpinned'); }
      } else {
        const res = await fetch(`${API}/pollen/me/pins`, { method: 'POST', credentials: 'include', headers: { ...authHeaders(), 'Content-Type': 'application/json' }, body: JSON.stringify({ entity_type: entityType, entity_id: entityId }) });
        if (res.ok) { setPinned(true); toast.success('Pinned — access it from My Profile'); }
      }
    } catch {
      toast.error('Failed to update pin');
    }
    setLoading(false);
  };

  return (
    <Button type="button" size={size} variant={pinned ? 'default' : variant} onClick={toggle}
      data-testid={`pin-btn-${entityType}-${entityId}`}
      title={pinned ? 'Unpin' : 'Pin for quick access'}>
      {pinned ? <Pin className="w-4 h-4" /> : <PinOff className="w-4 h-4" />}
      <span className="hidden sm:inline ml-1">{pinned ? 'Pinned' : 'Pin'}</span>
    </Button>
  );
};

export default PinButton;
